export const paths = {
  home: "/",
  login: {
    index: "/login",
  },
  changePassword: {
    index: "/change-password",
  },
  dashboard: {
    index: "/dashboard",
  },
  modules: {
    index: "/modules",
    view: ":view",
    add: "add",
  },
  statics: {
    index: "/statics",
    view: ":view",
    add: "add",
  },
  discounts: {
    index: "/discounts",
    view: ":view",
    add: "add",
  },
  users: {
    index: "/users",
    view: ":view",
    add: "add",
  },
  roles: {
    index: "/roles",
    view: ":view",
    add: "add",
  },
  primaryFields: {
    index: "/primary-fields",
  },
  media: {
    index: "/media",
  },
};
